import { createFeature, createReducer, on } from '@ngrx/store';
import { layoutChanged } from '../actions';

export const LAYOUT_FEATURE_KEY = 'layoutState';

export interface LayoutState {
  showBackgroundImage: boolean;
}

export const initialState: LayoutState = {
  showBackgroundImage: false,
};

export const layoutFeature = createFeature({
  name: LAYOUT_FEATURE_KEY,
  reducer: createReducer(
    initialState,
    on(layoutChanged, (state, changes) => ({
      ...state,
      ...changes,
    })),
  ),
});
